<template>
  <div class="paradigm_home_banner_footer">
    <div class="paradigm_home_banner_footer_item">
      <div class="inner">
        <span class="paradigm_home_banner_footer_memo">企业总数</span>
        <div class="paradigm_home_banner_footer_num">
          <span class="paradigm_home_banner_footer_value">
            <numberControl :num="staticNum.company"></numberControl> </span
          ><span class="paradigm_home_banner_footer_symbol">+</span>
        </div>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <div class="inner">
        <span class="paradigm_home_banner_footer_memo">考生总数</span>
        <div class="paradigm_home_banner_footer_num">
          <span class="paradigm_home_banner_footer_value"
            ><numberControl :num="staticNum.candsCount"></numberControl></span
          ><span class="paradigm_home_banner_footer_symbol">+</span>
        </div>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <div class="inner">
        <span class="paradigm_home_banner_footer_memo">累计发布考试</span>
        <div class="paradigm_home_banner_footer_num">
          <span class="paradigm_home_banner_footer_value"
            ><numberControl :num="staticNum.exams"></numberControl></span
          ><span class="paradigm_home_banner_footer_symbol">+</span>
        </div>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <div class="inner">
        <span class="paradigm_home_banner_footer_memo">试题总数</span>
        <div class="paradigm_home_banner_footer_num">
          <span class="paradigm_home_banner_footer_value"
            ><numberControl :num="staticNum.questions"></numberControl></span
          ><span class="paradigm_home_banner_footer_symbol">+</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numberControl from '@/components/tools/random-number'
export default {
  components: {
    numberControl,
  },
  data() {
    return {
      staticNum: {
        company: 0,
        candsCount: 0,
        exams: 0,
        questions: 0,
        perDay: 0,
      },
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.app.device
    },
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    if (this.loadConfig && this.loadConfig.examStatic) {
      this.staticNum = this.loadConfig.examStatic
    }
  },
  watch: {
    isMobile(newVal, oldVal) {
      if (newVal == 1) {
        this.show = false
      } else {
        this.show = true
      }
    },
    loadConfig(newVal, oldVal) {
      if (newVal.examStatic) {
        this.staticNum = newVal.examStatic
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.paradigm_home_banner_footer {
  width: 100%;
  height: 150px;
  box-sizing: border-box;
  padding-top: 42px;
  display: flex;
  justify-content: center;
  background-color: rgba(15, 16, 31, 0.7);
  position: absolute;
  z-index: 999;
  bottom: 60px;
}
.paradigm_home_banner_footer_item {
  text-align: center;
  margin-right: 5%;
}
.mobile-box .paradigm_home_banner_footer_item {
}
.paradigm_home_banner_footer_item:last-child {
  margin-right: 0;
}

.paradigm_home_banner_footer_value {
  font-size: 40px;
  line-height: 60px;
  font-weight: bold;
  color: white;
}

.paradigm_home_banner_footer_symbol {
  vertical-align: super;
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 3px;
  color: white;
}

.paradigm_home_banner_footer_memo {
  font-size: 16px;
  line-height: 1;
  margin-top: 4px;
  display: inline-block;
  letter-spacing: 2.1px;
  color: #29bdb9;
  font-weight: 300;
}
.paradigm_home_banner_footer_num {
  position: relative;
  right: -15px;
}
@media screen and (max-width: 600px) {
  .paradigm_home_banner_footer {
    position: initial;
    display: inline-block;
    height: initial;
    padding: 15px 0px 0 0;
    .paradigm_home_banner_footer_item {
      width: 50%;
      float: left;
      display: inline-table;
      margin: 0px;
      text-align: center;
      .paradigm_home_banner_footer_num {
        right: 0;
        .paradigm_home_banner_footer_value {
          font-size: 23px;
        }
        .paradigm_home_banner_footer_symbol {
          vertical-align: text-top;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .paradigm_home_banner_footer {
    position: initial;
    display: inline-block;
    height: initial;
    padding: 15px 0px 0 0;
    .paradigm_home_banner_footer_item {
      width: 50%;
      float: left;
      display: inline-table;
      margin: 0px;
      text-align: center;
      .paradigm_home_banner_footer_num {
        right: 0;
        .paradigm_home_banner_footer_value {
          font-size: 27px;
        }
        .paradigm_home_banner_footer_symbol {
          vertical-align: text-top;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/carousel/sitestatic.vue